import PictureComponent from "components/core/picture/picture-component";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { setCookie } from "services/cookies-service";
import { INSTALL_PRODUCTS_FLOW, MULTIPLE_PRODUCTS_SELECTION, SKIP_AB_TESTS_HP } from "constants/cookies";
import {
  cookieValues,
  procuctIdToCluster
} from "segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts";
import { CLUSTER_TYPE } from "constants/clusters/types";
import { updateUserClustersListWithMultipleClusters } from "services/clusters-service";
import { HP_TAGS_SELECTION } from "constants/clusters";
import { SM } from "constants/sizes";
import DefaultProps from "./default-props";
import { componentStyles } from "./product-sign-up.scss";

const PRODUCT_TYPE_TO_IMAGE = {
  [CRM_PRODUCT_ID]:
    "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162032.png",
  [DEV_PRODUCT_ID]:
    "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162033.png",
  [WORK_MANAGEMENT_PRODUCT_ID]:
    "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162031.png"
};

const ProductSignUp = ({
  displayImage,
  useCtaText,
  buttonSize,
  withButtonArrow,
  ctaText,
  productType = WORK_MANAGEMENT_PRODUCT_ID,
  selectedProductIds = [],
  signupClusterId,
  useCtaIcon,
  buttonColor = WHITE_COLOR_NAME,
  invert,
  excludeFromWMHighIntentExperienceTest
}) => {
  const getProductsCookiesKey = () => {
    if (selectedProductIds.length === 1) {
      return selectedProductIds[0];
    }
    if (selectedProductIds.length === 2) {
      const sortedIds = selectedProductIds.sort();
      return `${sortedIds[0]}_${sortedIds[1]}`;
    }
    return null;
  };

  const updateClusters = () => {
    const res = [];
    if (selectedProductIds.length < 3) {
      selectedProductIds.forEach((id) => {
        const clusterId = procuctIdToCluster[id];
        if (clusterId) res.push({ clusterId, clusterType: CLUSTER_TYPE });
      });
      updateUserClustersListWithMultipleClusters(res, HP_TAGS_SELECTION);
    }
  };

  const addTestCookiesAndClusters = (cookieKey) => {
    setCookie(SKIP_AB_TESTS_HP, true, {
      expires: 1 // 1 day
    });
    setCookie(MULTIPLE_PRODUCTS_SELECTION, true, {
      expires: 1 // 1 day
    });
    const productsKey = cookieKey || getProductsCookiesKey();
    if (productsKey) {
      const cookieArray = cookieValues[productsKey];
      cookieArray?.forEach((cookie) => {
        setCookie(cookie.key, cookie.value, {
          expires: 1 // 1 day
        });
      });
    } else {
      setCookie(INSTALL_PRODUCTS_FLOW, false, {
        expires: 1 // 1 day
      });
    }
    updateClusters();
  };

  return (
    <div className="product-sign-up">
      {displayImage ? (
        <div className="product-logo-image">
          <PictureComponent src={PRODUCT_TYPE_TO_IMAGE[productType]} />
        </div>
      ) : null}
      <SignupButton
        isWMHighIntentExperience={productType === WORK_MANAGEMENT_PRODUCT_ID}
        withButtonArrow={withButtonArrow}
        useCtaIcon={useCtaIcon}
        productIdToUse={productType}
        signupClusterId={signupClusterId}
        useCtaText={useCtaText}
        ctaText={ctaText}
        buttonSize={buttonSize || SM}
        buttonColor={buttonColor}
        invert={invert}
        beforeSubmitCallback={() => addTestCookiesAndClusters(productType)}
        skipUpdateCluster={true}
        signupProductId={productType}
        extraData={{ selectedProduct: productType }}
        excludeFromWMHighIntentExperienceTest={excludeFromWMHighIntentExperienceTest}
      />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ProductSignUp;

ProductSignUp.defaultProps = DefaultProps;
